import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  /**
   * Array of cached (failed) requests
   * @type {Array}
   */
  cachedRequests: Array<HttpRequest<any>> = [];

  /**
   * Constructor
   * @param {AuthService} auth
   */
  constructor(private auth: AuthService) {
  }

  /**
   * This can retry all failed requests when new token arrives. At least when it's implemented ;)
   */
  private retryFailedRequests(): void {
    // retry the requests. this method can
    // be called after the token is refreshed
  }

  /**
   * Angular interceptor function implementation.
   * Add token to http requests and cache failed requests if status code is https://http.cat/401
   * @param {HttpRequest<any>} request
   * @param {HttpHandler} next
   * @returns {Observable<HttpEvent<any>>}
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let req: HttpRequest<any>;
    if (request.url.includes('rata.digitraffic') || request.url.includes('uptimerobot')) {
      req = request;
    } else {
      req = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.auth.getToken()}`,
          'Content-Type': 'application/json'
        }
      });
    }
    return next.handle(req);
    // This was removed because it didn't work. Damn RXJS.
    /*
    .tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // do stuff with response if you want
      }
    }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          this.cachedRequests.push(request);
          // redirect to the login route
          // or show a modal
        }
      }
    })
     */
  }
}
